import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Wallet, Loader2, Check } from 'lucide-react';

export function WalletConnectModal({ open, onOpenChange, onConnected }) {
  const [status, setStatus] = useState('idle');
  const mockAddress = '0xAb7F...3f9E';
  const fullAddress = '0xAb7F4c2d8e1a9b3f5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d5e6f3f9E';

  const handleConnect = () => {
    setStatus('connecting');
    setTimeout(() => {
      setStatus('connected');
      if (onConnected) onConnected(fullAddress);
    }, 2000);
  };

  const handleClose = () => {
    onOpenChange(false);
    if (status !== 'connected') setTimeout(() => setStatus('idle'), 300);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-sm rounded-2xl border-0" data-testid="wallet-connect-modal">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-center">
            {status === 'connected' ? 'Wallet Connected' : 'Connect Wallet'}
          </DialogTitle>
          <DialogDescription className="text-center font-body">
            {status === 'connected' ? 'Your wallet is now linked to HumaClub' : 'Connect your crypto wallet for on-chain donations'}
          </DialogDescription>
        </DialogHeader>
        <div className="py-6 text-center">
          {status === 'idle' && (
            <div className="space-y-4">
              <div className="w-16 h-16 rounded-2xl bg-[#F6851B]/10 flex items-center justify-center mx-auto">
                <Wallet className="w-8 h-8 text-[#F6851B]" />
              </div>
              <Button onClick={handleConnect} className="w-full bg-[#F6851B] hover:bg-[#E2761B] text-white rounded-full h-11 font-medium border-0 transition-all" data-testid="metamask-connect-btn">
                <Wallet className="w-4 h-4 mr-2" /> Connect MetaMask
              </Button>
              <p className="text-xs text-gray-400 font-body">Other wallets coming soon</p>
            </div>
          )}
          {status === 'connecting' && (
            <div className="space-y-4" data-testid="wallet-connecting">
              <div className="w-16 h-16 rounded-2xl bg-[#F6851B]/10 flex items-center justify-center mx-auto">
                <Loader2 className="w-8 h-8 text-[#F6851B] animate-spin" />
              </div>
              <p className="font-heading font-medium text-[#111827]">Connecting to MetaMask...</p>
              <p className="text-sm text-gray-500 font-body">Please confirm in your wallet</p>
            </div>
          )}
          {status === 'connected' && (
            <div className="space-y-4" data-testid="wallet-connected">
              <div className="w-16 h-16 rounded-full bg-[#10B981]/10 flex items-center justify-center mx-auto">
                <Check className="w-8 h-8 text-[#10B981]" />
              </div>
              <div className="bg-gray-50 rounded-xl px-4 py-3">
                <p className="text-xs text-gray-500 font-body mb-1">Connected Address</p>
                <code className="text-sm font-mono text-[#111827]">{mockAddress}</code>
              </div>
              <Button onClick={handleClose} className="w-full bg-gradient-to-r from-[#7C3AED] to-[#2563EB] text-white rounded-full h-11 font-medium border-0" data-testid="wallet-done-btn">
                Done
              </Button>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default WalletConnectModal;
